<div class="header">
  <div class="left">
    @if (showBackButton) {
      <img data-cy="header-back-button" class="back-button arabic-transform" src="assets/icon/big-arrow-left.svg" alt="" (click)="navigateBack.emit()" />
    }

    <div class="title-container" [class.mobile]="appService.isMobile$ | async" (click)="goTo('home')" >
      @if (customTitle) {
        <div class="custom-title">{{ customTitle }}</div>
      } @else {
        <img src="assets/logo/wr-icon-outline.svg" alt="" />
        <div class="title">{{ 'PWA_banner_mobile_openApp_header' | translate }}</div>
      }
    </div>
  </div>

  <div class="right">
    @if (showAvatar) {
      @if ((userState.isGuest$ | async) && ((flagsState.flags$ | async)?.walkthroughCompletedOrDismissed)) {
        <div data-cy="sign-in-container" class="sign-in-container" [class.mobile]="appService.isMobile$ | async" (click)="goTo('authentication')">
          <div class="sign-in">{{ 'PWA_homeLibrary_header_guest_signIn' | translate }}</div>
          <div class="person-img" [class.mobile]="appService.isMobile$ | async"></div>
        </div>
      } @else {
        <img
          data-cy="header-sprouty-icon"
          (click)="startHomeTour()"
          id="walkThroughAlwaysHighlight"
          src="assets/imgs/header/sprouty/{{ (productTourService.currentStep$ | async)?.sproutyIcon || 'default.svg' }}"
          alt=""
          class="buddy"
          [class.tour-highlight]="productTourService.productTourRunning$ | async"
        />
      }
    }
  </div>
</div>

